// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kuEPr","fullView":"styles_fullView__ONg2Y"};